var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 62C48.1208 62 62 48.1208 62 31C62 13.8792 48.1208 0 31 0C13.8792 0 0 13.8792 0 31C0 48.1208 13.8792 62 31 62Z",
    fill: "#0F7986"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.911 28.6413L45.914 12.6367L16.1709 49.4436L28.6502 61.9119C29.4257 61.9699 30.2092 62 30.9998 62C48.1205 62 61.9998 48.1208 61.9998 31C61.9998 30.2063 61.9697 29.4199 61.911 28.6413Z",
    fill: "#0D6671"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4917 49.9445H44.5081C45.6082 49.9445 46.5 49.0527 46.5 47.9526V14.0474C46.5 12.9473 45.6082 12.0557 44.5081 12.0557H17.4917C16.3916 12.0557 15.5 12.9475 15.5 14.0474V47.9526C15.5 49.0527 16.3918 49.9445 17.4917 49.9445Z",
    fill: "#BDC3C7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5079 12.0557H30.8257V49.9445H44.5079C45.608 49.9445 46.4998 49.0527 46.4998 47.9526V14.0476C46.4998 12.9475 45.608 12.0557 44.5079 12.0557Z",
    fill: "#9DA0A3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9427 14.8213H18.0571V47.1782H43.9427V14.8213Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9428 14.8213H30.8262V47.1782H43.9428V14.8213Z",
    fill: "#E3E5E4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6193 10.3331H34.4447C34.4447 8.43074 32.9026 6.88867 31.0002 6.88867C29.0978 6.88867 27.5558 8.43074 27.5558 10.3331H25.3812C24.6798 10.3331 24.1113 10.9018 24.1113 11.603V15.9519C24.1113 16.6534 24.68 17.2218 25.3812 17.2218H36.619C37.3205 17.2218 37.8889 16.6532 37.8889 15.9519V11.603C37.8891 10.9018 37.3205 10.3331 36.6193 10.3331Z",
    fill: "#3498DB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6191 10.3331H34.4445C34.4445 8.43074 32.9024 6.88867 31.0001 6.88867C30.9414 6.88867 30.8842 6.89452 30.8262 6.89744V17.222H36.6191C37.3205 17.222 37.889 16.6534 37.889 15.9521V11.603C37.889 10.9018 37.3203 10.3331 36.6191 10.3331Z",
    fill: "#2980B9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9999 11.7946C31.8069 11.7946 32.4611 11.1404 32.4611 10.3334C32.4611 9.52631 31.8069 8.87207 30.9999 8.87207C30.1928 8.87207 29.5386 9.52631 29.5386 10.3334C29.5386 11.1404 30.1928 11.7946 30.9999 11.7946Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1281 23.2758C22.7622 23.2758 23.2763 22.7617 23.2763 22.1276C23.2763 21.4935 22.7622 20.9795 22.1281 20.9795C21.494 20.9795 20.98 21.4935 20.98 22.1276C20.98 22.7617 21.494 23.2758 22.1281 23.2758Z",
    fill: "#3498DB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1281 29.852C22.7622 29.852 23.2763 29.3379 23.2763 28.7038C23.2763 28.0697 22.7622 27.5557 22.1281 27.5557C21.494 27.5557 20.98 28.0697 20.98 28.7038C20.98 29.3379 21.494 29.852 22.1281 29.852Z",
    fill: "#3498DB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1281 36.7406C22.7622 36.7406 23.2763 36.2266 23.2763 35.5925C23.2763 34.9584 22.7622 34.4443 22.1281 34.4443C21.494 34.4443 20.98 34.9584 20.98 35.5925C20.98 36.2266 21.494 36.7406 22.1281 36.7406Z",
    fill: "#3498DB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1281 43.3168C22.7622 43.3168 23.2763 42.8028 23.2763 42.1687C23.2763 41.5346 22.7622 41.0205 22.1281 41.0205C21.494 41.0205 20.98 41.5346 20.98 42.1687C20.98 42.8028 21.494 43.3168 22.1281 43.3168Z",
    fill: "#3498DB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9326 22.8587H26.8249C26.4214 22.8587 26.0942 22.5316 26.0942 22.1281C26.0942 21.7246 26.4214 21.3975 26.8249 21.3975H38.9326C39.3361 21.3975 39.6633 21.7246 39.6633 22.1281C39.6633 22.5316 39.3361 22.8587 38.9326 22.8587Z",
    fill: "#BDC3C7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9326 29.4339H26.8249C26.4214 29.4339 26.0942 29.1068 26.0942 28.7033C26.0942 28.2998 26.4214 27.9727 26.8249 27.9727H38.9326C39.3361 27.9727 39.6633 28.2998 39.6633 28.7033C39.6633 29.1068 39.3361 29.4339 38.9326 29.4339Z",
    fill: "#BDC3C7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9326 36.3236H26.8249C26.4214 36.3236 26.0942 35.9965 26.0942 35.5929C26.0942 35.1894 26.4214 34.8623 26.8249 34.8623H38.9326C39.3361 34.8623 39.6633 35.1894 39.6633 35.5929C39.6633 35.9965 39.3361 36.3236 38.9326 36.3236Z",
    fill: "#BDC3C7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9326 42.8988H26.8249C26.4214 42.8988 26.0942 42.5717 26.0942 42.1681C26.0942 41.7646 26.4214 41.4375 26.8249 41.4375H38.9326C39.3361 41.4375 39.6633 41.7646 39.6633 42.1681C39.6633 42.5717 39.3361 42.8988 38.9326 42.8988Z",
    fill: "#BDC3C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardSvgrepoCom);
export default __webpack_public_path__ + "static/media/clipboard-svgrepo-com.2630d9c9.svg";
export { ForwardRef as ReactComponent };